import { Reducer } from 'redux';
import {
  FilterContactsList,
  GetContactsList,
  initialContactsState,
  TContactActions,
  TContactsState,
} from '../types/Contacts';
import { endReducer } from '../store/Store';

export const contactReducer: Reducer<TContactsState, TContactActions> = (
  state = initialContactsState,
  action
)=> {
  switch (action.type) {
    case GetContactsList.REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GetContactsList.SUCCESS:
      const photoUrls = action.payload.data.profilePhotoUrls || {};
      const contacts = action.payload.data.contacts.map((contact) => ({
        ...contact,
        profilePhotoUrl: photoUrls[contact.id] || null,
      }));
      return {
        ...state,
        loading: false,
        data: contacts,
        filteredList: contacts,
      };

    case GetContactsList.FAILED:
      return {
        ...state,
        loading: false,
      }

    case FilterContactsList.SUBMIT:
      const searchPhrase = action.payload.search.toLocaleLowerCase();
      const searchLocation = action.payload.location.toLocaleLowerCase();
      const searchGroup = action.payload.group.toLocaleLowerCase();

      return {
        ...state,
        filteredList: state.data?.filter((val) => {
          const searchCondition = val.name
            .toLocaleLowerCase()
            .includes(searchPhrase);

          if (searchLocation) {
            return (
              val.accessibleLocations
                .map((location) => location.title.toLocaleLowerCase())
                .includes(searchLocation)
            );
          }

          if (searchGroup) {
            return (
              val.accessibleDepartments
                .map((group) => group.title.toLocaleLowerCase())
                .includes(searchGroup)
            );
          }

          return searchCondition;
        }),
        searchPhrase,
        searchLocation,
        searchGroup,
      };

    default:
      return endReducer(state,action);
  }
};